import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Card, CardBody, Form, FormGroup, Label, Input, Button, Alert } from 'reactstrap'
import { Breadcrumbs } from '../../AbstractElements'
import HeaderCard from '../Common/Component/HeaderCard'
import { getIdData } from '../../lib/studentinfo'
import { updateData } from '../../lib/profiles'
import { useNavigate, useParams } from 'react-router-dom'
import { ClassForLessonSelect, RoleSelect } from '../Common/FormSelects'

const AdminStudentRoleChange = () => {
	const [formData, setFormData] = useState({
		name: '',
		surname: '',
		class: 9,
		role: ''
	})
	const [loading, setLoading] = useState(false)
	const [saving, setSaving] = useState(false)
	const [error, setError] = useState('')

	const navigate = useNavigate()
	const { id } = useParams()

	const handleInputChange = (field, value) => {
		setFormData((prev) => ({
			...prev,
			[field]: value
		}))
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		setSaving(true)
		setError('')

		try {
			await updateData({
				id: id,
				class: formData.class,
				role: formData.role
			})
			navigate(-1)
		} catch (error) {
			setError('Failed to update student role: ' + error.message)
		} finally {
			setSaving(false)
		}
	}

	const fetchStudentData = async () => {
		try {
			setLoading(true)
			const info = await getIdData(id)
			if (info && info[0]) {
				const student = info[0]
				setFormData({
					name: student.name || '',
					surname: student.surname || '',
					class: student.class || 9,
					role: student.role || ''
				})
			}
		} catch (error) {
			setError('Failed to load student information: ' + error.message)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		fetchStudentData()
	}, [id])

	if (loading) {
		return (
			<Container fluid={true}>
				<Row>
					<Col sm="12">
						<Card>
							<CardBody className="text-center">
								<div className="spinner-border" role="status">
									<span className="visually-hidden">Loading...</span>
								</div>
								<p className="mt-2">Loading student information...</p>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
		)
	}

	return (
		<>
			<Breadcrumbs parent="Student Management" title="Update Role" mainTitle="Update Student Role" />
			<Container fluid={true}>
				<Row>
					<Col sm="12">
						<Card>
							<HeaderCard title="Update Role" subTitle="Change student role and grade level" />
							<CardBody>
								{error && (
									<Alert color="danger" className="mb-3">
										{error}
									</Alert>
								)}

								<Form onSubmit={handleSubmit}>
									<Row>
										<Col md="6">
											<FormGroup>
												<Label for="name">First Name</Label>
												<Input
													id="name"
													type="text"
													value={formData.name}
													onChange={(e) => handleInputChange('name', e.target.value)}
													placeholder="Enter first name"
													disabled
												/>
											</FormGroup>
										</Col>
										<Col md="6">
											<FormGroup>
												<Label for="surname">Last Name</Label>
												<Input
													id="surname"
													type="text"
													value={formData.surname}
													onChange={(e) => handleInputChange('surname', e.target.value)}
													placeholder="Enter last name"
													disabled
												/>
											</FormGroup>
										</Col>
									</Row>

									<Row>
										<Col md="6">
											<FormGroup>
												<Label for="role">Role *</Label>
												<RoleSelect value={formData.role} setValue={(value) => handleInputChange('role', value)} />
											</FormGroup>
										</Col>
										<Col md="6">
											<FormGroup>
												<Label for="class">Grade Level</Label>
												<ClassForLessonSelect
													value={formData.class}
													setValue={(value) => handleInputChange('class', value)}
													name="ClassForLessonSelect"
												/>
											</FormGroup>
										</Col>
									</Row>

									<div className="d-flex justify-content-between mt-4">
										<Button type="submit" color="primary" disabled={saving || !formData.role}>
											{saving ? 'Updating...' : 'Update'}
										</Button>
										<Button type="button" color="secondary" onClick={() => navigate(-1)} disabled={saving}>
											Cancel
										</Button>
									</div>
								</Form>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
		</>
	)
}

export { AdminStudentRoleChange }
